module.exports = __webpack_public_path__ + "img/2e34e68a7dc33dc2a634585fb4271b9e.e1269551.jpg";